import { render, staticRenderFns } from "./ProjektStartenUsability.vue?vue&type=template&id=0b07c122&scoped=true&"
import script from "./ProjektStartenUsability.vue?vue&type=script&lang=js&"
export * from "./ProjektStartenUsability.vue?vue&type=script&lang=js&"
import style0 from "./ProjektStartenUsability.vue?vue&type=style&index=0&id=0b07c122&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b07c122",
  null
  
)

export default component.exports